import { render, staticRenderFns } from "./FormUpdatePassword.vue?vue&type=template&id=1b11886a&scoped=true"
import script from "./FormUpdatePassword.vue?vue&type=script&lang=js"
export * from "./FormUpdatePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b11886a",
  null
  
)

export default component.exports